<template>
  <div
    class="calciatore-battuto"
    v-if="Calciatore"
    :class="[sizeClass, { clickable: isClickable }]"
    :style="{
      backgroundImage: `url(${
        Calciatore.ID_Club
          ? Config.PUBLIC_DIR +
            '/clubs/maglie/400x400/ID_Anno_' +
            Config.ID_ANNO_MAGLIE +
            '/img_scheda_club_' +
            Calciatore.ID_Club +
            '.png'
          : ''
      })`,
    }"
    @click="handleClick"
  >
    <div v-if="sizeClass == 'extra-small'" class="extra-small-content">
      <span
        v-if="classic"
        :class="['Ruolo', 'Ruolo_' + Calciatore.ID_Ruolo]"
        >{{ ruolo(Calciatore.ID_Ruolo) }}</span
      >
      <div class="extra-small-details">
        <span class="nomeCalciatore" :title="Calciatore.calciatore">
          {{ Calciatore.calciatore }}
        </span>
        <span v-if="Calciatore.nomeClub" class="nomeClub ellipsis">
          {{ Calciatore.nomeClub }}
        </span>
      </div>
      <quotazione
        v-if="showQuotazione"
        :quotazione="Calciatore.quotazione"
        small
      ></quotazione>
      <main-status
        v-if="Calciatore.ms"
        :ms="Calciatore.ms"
        small
      ></main-status>
      <span class="extra-small-shirt-spacer"></span>
    </div>
    <div v-else-if="sizeClass != 'small'">
      <div class="nomeCalciatore">
        <span
          v-if="classic"
          :class="['Ruolo', 'Ruolo_' + Calciatore.ID_Ruolo]"
          >{{ ruolo(Calciatore.ID_Ruolo) }}</span
        >
        {{ Calciatore.calciatore }}
        <span v-if="mantra">
          <span
            v-for="mantra_id in Calciatore.mantra_ids"
            :key="mantra_id"
            :class="['ml-1', 'ruolo-mantra', 'ruolo-mantra' + mantra_id]"
            >{{ ruoloMantra(mantra_id) }}</span
          >
        </span>
      </div>
      <div class="photo">
        <div class="imgCalciatore without-ms">
          <div class="imgContainer imgContainer-ruolo_">
            <div
              v-if="Config.AVATAR_OR_FLAG == 'avatar'"
              class="img"
              :key="Calciatore.nid"
              :style="{
                backgroundImage: `url(${
                  Calciatore.imgCalciatore
                    ? Calciatore.imgCalciatore
                    : Config.PUBLIC_DIR +
                      '/schede_calciatori/avatar/default/avatar_club_' +
                      Calciatore.ID_Club +
                      '.png'
                })`,
              }"
            ></div>

            <div
              v-if="Config.AVATAR_OR_FLAG == 'flag'"
              class="img flag"
              :key="Calciatore.nid"
              :style="{
                backgroundImage: `url(${
                  Config.PUBLIC_DIR +
                  '/clubs/flags/flag_' +
                  Calciatore.ID_Club +
                  '.png'
                })`,
              }"
            ></div>
          </div>
        </div>
      </div>

      <span class="nomeClub ellipsis">{{ Calciatore.nomeClub }}</span>
      <quotazione
        v-if="showQuotazione"
        :quotazione="Calciatore.quotazione"
      ></quotazione>
      <span class="mainStatusPlaceholder"
        ><main-status :ms="Calciatore.ms"></main-status
      ></span>
    </div>
    <div v-else class="d-flex">
      <div class="photo">
        <span :class="['Ruolo', 'Ruolo_' + Calciatore.ID_Ruolo]">{{
          ruolo(Calciatore.ID_Ruolo)
        }}</span>
        <div class="imgCalciatore without-ms">
          <div class="imgContainer imgContainer-ruolo_">
            <div
              v-if="Config.AVATAR_OR_FLAG == 'avatar'"
              class="img"
              :key="Calciatore.nid"
              :style="{
                backgroundImage: `url(${
                  Calciatore.imgCalciatore
                    ? Calciatore.imgCalciatore
                    : Config.PUBLIC_DIR +
                      '/schede_calciatori/avatar/default/avatar_club_' +
                      Calciatore.ID_Club +
                      '.png'
                })`,
              }"
            ></div>

            <div
              v-if="Config.AVATAR_OR_FLAG == 'flag'"
              class="img flag"
              :key="Calciatore.nid"
              :style="{
                backgroundImage: `url(${
                  Config.PUBLIC_DIR +
                  '/clubs/flags/flag_' +
                  Calciatore.ID_Club +
                  '.png'
                })`,
              }"
            ></div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column align-start justify-space-around">
        <div class="nomeCalciatore">
          {{ Calciatore.calciatore }}
        </div>
        <span class="nomeClub ellipsis">{{ Calciatore.nomeClub }}</span>
      <div class="d-flex align-center">
         <main-status
          v-if="Calciatore.ms"
          :ms="Calciatore.ms"
          small
        ></main-status>
        <quotazione
          v-if="showQuotazione"
          :quotazione="Calciatore.quotazione"
          small
          class="ml-1"
        ></quotazione>

      </div>
      </div>

    </div>
  </div>
</template>

<script>
import Vuex from "vuex";

import db from "../../js/db";
import mixins from "../../js/mixins";
import Config from "../../../config-app/config";
import Constants from "../../js/constants";
import MainStatus from "./MainStatus";
import Quotazione from "./Quotazione";

export default {
  name: "calciatore-battuto",
  mixins: [mixins],
  components: {
    MainStatus,
    Quotazione,
  },
  props: {
    id: {
      type: [String, Object],
      required: true,
    },
    clicked: {
      type: Function,
      default: null,
    },
    xLarge: {
      type: Boolean,
    },
    small: {
      type: Boolean,
    },
    large: {
      type: Boolean,
    },
    extraSmall: {
      type: Boolean,
    },
  },
  mounted() {},
  computed: {
    sizeClass() {
      if (this.extraSmall) {
        return "extra-small";
      }

      if (this.small) {
        return "small";
      }

      if (this.large) {
        return "large";
      }

      if (!this.xLarge) {
        if (
          this.squadreSize &&
          this.squadreSize == Constants.SQUADRE_SIZE.SMALL
        ) {
          return "small";
        }
        if (
          this.squadreSize &&
          this.squadreSize == Constants.SQUADRE_SIZE.MEDIUM
        ) {
          return "medium";
        }
        if (
          this.squadreSize &&
          this.squadreSize == Constants.SQUADRE_SIZE.LARGE
        ) {
          return "large";
        }
      }

      return "x-large";
    },
    Calciatore() {
      if(typeof this.id === 'string'){
        return this.calciatori[this.id];
      }else{
        return this.id // workaround
      }
    },
    showQuotazione() {
      return (
        this.asta_settings &&
        this.asta_settings.base_asta == Constants.BASE_ASTA.QUOTAZIONE
      );
    },
    isClickable() {
      return Boolean(this.clicked) || Config.AVATAR_OR_FLAG === "avatar";
    },
    galleryCalciatoreId() {
      if (typeof this.id === "string") {
        return this.id;
      }

      const storeId = Object.keys(this.calciatori || {}).find(
        (id) => this.calciatori[id] === this.id
      );

      return storeId || this.id.id || this.id.nid || null;
    },
    ...Vuex.mapGetters(["calciatori", "squadreSize"]),
  },
  methods: {
    handleClick(event) {
      if (this.clicked) {
        this.clicked(event);
        return;
      }

      if (Config.AVATAR_OR_FLAG === "avatar" && this.galleryCalciatoreId) {
        db.emit("showDialogGalleriaCalciatori", this.galleryCalciatoreId);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.calciatore-battuto {
  color: #ffffff;
  background-color: var(--v-navy-base);
  // background-image: linear-gradient(#607d8b, #455a64);
  border-radius: 1em;
  box-shadow: 0px 1px 14px 10px rgb(0 0 0 / 12%);
  // x-large
  width: 270px;
  padding: 10px;
  text-align: center;
  margin: 15px auto 10px;
  background-size: cover;
  background-position: 120px -25px;
  position: relative;
  &.clickable {
    cursor: pointer;
    transition: filter 0.18s ease, box-shadow 0.18s ease,
      transform 0.18s ease;
  }
  &.large {
    width: 220px;
    padding: 10px 0px 0px 10px;
    background-position: 108px -25px;
    .photo {
      margin-left: 25px;
      margin-top: 7px;
      .imgCalciatore {
        width: 70px;
        height: 70px;
        .imgContainer {
          .img {
            width: 65px;
          }
        }
      }
    }
  }
  &.medium {
    width: 180px;
    padding: 5px 0px 0px 10px;
    background-position: 90px -25px;
    .photo {
      margin-left: 15px;
      margin-top: 5px;
      .imgCalciatore {
        width: 50px;
        height: 50px;
        .imgContainer {
          .img {
            width: 45px;
          }
        }
      }
    }
  }
  &.small {
    width: 200px;
    background-position: 135px -12px;
    background-size: 115px;
    font-size: 11px;
    .photo {
      position: relative;
      margin-left: 0;
      margin-top: 0;
      margin-right: 3px;
      .Ruolo {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        margin-right: 0;
      }
      .imgCalciatore {
        width: 50px;
        height: 50px;
        .imgContainer {
          .img {
            width: 45px;
          }
        }
      }
    }
  }
  &.extra-small {
    width: 220px;
    max-width: 100%;
    min-height: 32px;
    height: 32px;
    margin: 0;
    padding: 3px 6px;
    border-radius: 5px;
    background-position: right 0px top -4px;
    background-size: 65px;
    box-shadow: 0px 1px 8px 3px rgb(0 0 0 / 12%);

    .extra-small-content {
      height: 100%;
      display: flex;
      align-items: center;
      gap: 5px;
      min-width: 0;
      overflow: hidden;
    }

    .Ruolo {
      flex: 0 0 auto;
      margin-right: 0;
      font-size: 10px;
      line-height: 15px;
      min-width: 16px;
      padding: 0 3px;
      box-shadow: none;
    }

    .extra-small-details {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      gap: 1px;
      overflow: hidden;
      text-align: left;
    }

    .nomeCalciatore {
      display: block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      line-height: 1.1;
    }

    .nomeClub {
      display: block;
      width: 100%;
      color: rgba(255, 255, 255, 0.72);
      font-size: 10px;
      line-height: 1.1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    // .mainStatusExtraSmall::v-deep.ms- {
    //   flex: 0 0 auto;
    //   width: 16px;
    //   height: 16px;
    //   min-width: 16px;
    //   font-size: 8px;
    //   margin: 0;
    // }

    // .mainStatusExtraSmall::v-deep.ms-sq {
    //   width: 12px;
    //   height: 16px;
    //   min-width: 12px;
    // }

    // .mainStatusExtraSmall::v-deep.ms-inf {
    //   font-size: 15px;
    // }

    .extra-small-shirt-spacer {
flex: 0 0 60px;
    width: 60px;
      height: 1px;
    }
  }
  .photo {
    margin-left: 1em;
    margin-top: 1em;
    .imgCalciatore {
      width: 90px;
      height: 90px;
      margin: 0;
      .imgContainer {
        box-shadow: 0px 1px 10px 3px rgb(0 0 0 / 12%);
        .img {
          width: 80px;
          &.flag {
            width: 80%;
          }
        }
      }
    }
  }
  .Ruolo {
    margin-right: 10px;
    box-shadow: 0px 1px 10px 3px rgb(0 0 0 / 12%);
  }
  span.mainStatusPlaceholder {
    position: absolute;
    bottom: 5px;
    right: 10px;
    background: rgba(0, 0, 0, .3);
    border-radius: 100px;
    padding: 5px;
    display: flex;
    align-items: center;
  }
  .nomeCalciatore {
    font-weight: 700;
    font-size: 1.2em;
    line-height: 1em;
    display: flex;
    align-items: center;
  }
  .nomeClub {
    color: #263238;
  }
}

@media (hover: hover) {
  .calciatore-battuto.clickable:hover {
    filter: brightness(1.06);
    box-shadow: 0 4px 10px rgb(0 0 0 / 20%);
    transform: translateY(-1px);
  }
}
</style>
